import React from 'react';
import { NavLink } from 'react-router-dom';

declare var THD_ACCOUNT_GLOBAL: any;

/* eslint jsx-a11y/label-has-associated-control: ["error", { assert: "either" } ] */
function LeftNavigation() {
  const navigationSwitches = THD_ACCOUNT_GLOBAL.navigationSwitches || {};
  return (
    <div className="col__12-12 body__height--full u--paddingNone">
      <section className="accordion_wrapper accordion__wrapper--medium accordion__wrapper--noborders">
        <div className="accordion__item">
          <input
            className="accordion__input"
            id="ac-1"
            name="accordion-1"
            type="checkbox"
            defaultChecked
          />
          <label className="accordion__label" htmlFor="ac-1">
            <div className="accordion__trigger">
              <div className="accordion__plus" />
            </div>
            Orders &amp; Purchases
          </label>
          <div className="accordion__content-wrapper">
            <div className="accordion__content">
              <NavLink
                className="u__default-link account__nav--subnav"
                activeClassName="u__default-link account__nav--subnav router-link-active"
                to="/order/view/summary"
              >
                Online Orders
              </NavLink>
              <a
                className="u__default-link account__nav--subnav"
                href="/account/view/ordersubscription"
              >
                Subscriptions
              </a>
              <NavLink
                className="u__default-link account__nav--subnav"
                activeClassName="u__default-link account__nav--subnav router-link-active"
                to="/order/view/ereceipt/summary"
              >
                In Store e-Receipts
              </NavLink>
              <NavLink
                className="u__default-link account__nav--subnav"
                activeClassName="u__default-link account__nav--subnav router-link-active"
                to="/order/view/instoresummary"
              >
                In Store Orders
              </NavLink>
              <a
                className="u__default-link account__nav--subnav"
                target="_blank"
                rel="noopener noreferrer"
                href="https://hdapps.homedepot.com/MyInstall/Customer/MyInstallOrderSummary.jsp?forwardPage=OrderSummary&Sourceflag=1"
              >
                Installation Orders
              </a>
            </div>
          </div>
        </div>
        <div className="accordion__item">
          <input
            className="accordion__input"
            id="ac-3"
            name="accordion-3"
            type="checkbox"
            defaultChecked
          />
          <label className="accordion__label" htmlFor="ac-3">
            <div className="accordion__trigger">
              <div className="accordion__plus" />
            </div>
            Account Information
          </label>
          <div className="accordion__content-wrapper">
            <div className="accordion__content">
              <a
                className="u__default-link account__nav--subnav"
                href="/account/view/profile"
              >
                Profile
              </a>
              <a
                className="u__default-link account__nav--subnav"
                href="/account/view/addresses"
              >
                Address Book
              </a>
              <a
                className="u__default-link account__nav--subnav"
                href="/account/view/paymentcards"
              >
                My Payment Methods
              </a>
              {navigationSwitches.CITI_SSO_ENABLED === 1 && (
                <a
                  className="u__default-link account__nav--subnav"
                  href="/account/view/thdcreditcard"
                >
                  My Home Depot Credit Card
                </a>
              )}
              <a
                className="u__default-link account__nav--subnav"
                href="/account/view/instantcheckout"
              >
                Instant Checkout Settings
              </a>
              <a
                className="u__default-link account__nav--subnav"
                href="/account/view/emailsubscription"
              >
                Email Preferences
              </a>
              <NavLink
                className="u__default-link account__nav--subnav"
                activeClassName="u__default-link account__nav--subnav router-link-active"
                to="/order/view/myratingsandreviews"
              >
                My Ratings &amp; Reviews
              </NavLink>
              <a
                className="u__default-link account__nav--subnav"
                target="_blank"
                rel="noopener noreferrer"
                href="https://install.homedepot.com/MyWindowTreatments"
              >
                My Window Treatments
              </a>
            </div>
          </div>
        </div>
        <div className="accordion__item">
          <input
            className="accordion__input"
            id="ac-4"
            name="accordion-4"
            type="checkbox"
            defaultChecked
          />
          <label className="accordion__label" htmlFor="ac-4">
            <div className="accordion__trigger">
              <div className="accordion__plus" />
            </div>
            Lists
          </label>
          <div className="accordion__content-wrapper">
            <div className="accordion__content">
              <a
                className="u__default-link account__nav--subnav"
                href="/list/view/summary"
              >
                My Lists
              </a>
              <a
                className="u__default-link account__nav--subnav"
                href="/list/view/search"
              >
                Find a List
              </a>
            </div>
          </div>
        </div>
        <div className="accordion__item">
          <input
            className="accordion__input"
            id="ac-9"
            name="accordion-9"
            type="checkbox"
            defaultChecked
          />
          <label className="accordion__label" htmlFor="ac-9">
            <div className="accordion__trigger">
              <div className="accordion__plus" />
            </div>
            Credit &amp; Gift Cards
          </label>
          <div className="accordion__content-wrapper">
            <div className="accordion__content">
              <a
                className="u__default-link account__nav--subnav"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.homedepot.com/c/Credit_Center"
              >
                Pay Credit Card
              </a>
              <a
                className="u__default-link account__nav--subnav"
                target="_blank"
                href="/mycheckout/giftcard"
              >
                Gift Card Balance
              </a>
              <a
                className="u__default-link account__nav--subnav"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.homedepot.com/c/Credit_Center"
              >
                Credit Center
              </a>
              {navigationSwitches.CITI_SSO_ENABLED === 1 && (
                <a
                  className="u__default-link account__nav--subnav"
                  href="/account/view/thdcreditcard"
                >
                  My Home Depot Credit Card
                </a>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default LeftNavigation;
